export default function WorkstationController(
  $q,
  $rootScope,
  alerts,
  userService,
  bcpDataService,
  confirmDialog,
  editWorkstationDialog,
  ssDialogService
) {
  const vm = this;

  vm.canExpand = true;
  vm.isExpanded = false;

  vm.handleEdit = _handleEdit;
  vm.handleDelete = _handleDelete;

  _activate()

  /** *********************************************
   * Private Functions
   */

  function _activate() {
    _initEventListeners();
    _initPermissions();
  }

  function _initEventListeners() {
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('bcp').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _handleEdit($event) {
    ssDialogService.dialogs.bcp.editWorkstationDialog = ssDialogService.alert(
      editWorkstationDialog.getOptions($event, {
        assessmentId: vm.assessmentId,
        customerId: vm.customerId,
        workstation: vm.workstation,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.editWorkstationDialog);
  }

  function _handleDelete($event) {
    ssDialogService.dialogs.bcp.confirmDeleteWorkstationDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Workstation?',
        message: `Are you sure you want to delete the Workstation "${vm.workstation.name}"?`,
        handleYesClick() {
          _handleConfirmDelete(vm.workstation);
        },
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.bcp.confirmDeleteWorkstationDialog);
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.bcp.confirmDeleteWorkstationDialog);
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _handleConfirmDelete(workstation) {
    return bcpDataService.deleteWorkstation(workstation.assessmentWorkstationId).then(() => {
      alerts.success('The Workstation has been deleted successfully.');
      $rootScope.$broadcast('setDocumentRegenerateFlag');
      $rootScope.$broadcast('refreshBCPWorkstations');
      _closeDeleteDialog();
    })
    .catch(() => {
      alerts.error('An error occurred while deleting the Workstation.');
    });
  }
}

WorkstationController.$inject = [
  '$q',
  '$rootScope',
  'alerts',
  'userService',
  'bcpDataService',
  'confirmDialog',
  'editWorkstationDialog',
  'ssDialogService'
];
